import billingModule from '../../billing.module';
import template from './billing.component.html';

export default billingModule.component('billing', {
    template: template,
    controller(sessionService, sessionTypeConstants) {
        var vm = this;

        vm.$onInit = () => {
            vm.isGuestUser =
                sessionService.getSessionType() == sessionTypeConstants.guest;
        };
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing/billing.component.js